<template>
    <div class="d-flex justify-content-center flex-wrap py-3">
        <div class="col-12 col-sm-4 text-center bg-white shadow rounded p-5">
            <h3 class="text-nowrap">
                {{ $t(`Auth.${this.$route.name}.RouteName`) }}
            </h3>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'EmailConfirmationInProgress',
    computed: {
        ...mapGetters(['apiPath', 'omsApiKey']),
    },
    methods: {
        ...mapMutations(['setErrorFromServer']),
        confirm_email() {
            this.$http
                .post(`${this.apiPath}/email/confirm_email`, { token: this.$route.query.token }, {
                    headers: {
                        "x-api-key": this.omsApiKey
                    },
                })
                .then((res) => {
                    switch (res.data) {
                        case 'Request Expired':
                            this.$toast.error(this.$t('Auth.RequestExpired.expired'))
                            this.$router.replace('/')
                            break;
                        default:
                        this.$toast.success(`${this.$t('Auth.EmailConfirmed.succeeded')}: <strong>${res.data}</strong> <p class="m-0">${this.$t('Auth.EmailConfirmed.thanks')}</p> <p>${this.$t('Auth.EmailConfirmed.login_now')}</p>`)
                            this.$router.replace('/')
                            break;
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        }
    },
    created() {
        this.confirm_email()
    }
}
</script>